/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByDescription } from './Scaffolding';
import {
    TextField,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    SimpleShowLayout,
    ReferenceField,
    Datagrid,
    ReferenceInput,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { EditToolbar } from '../layout/EditToolbar';
import { AutocompleteInput, BooleanInput, TextInput } from '../lib/wrappers/Inputs';

export const QualificationTypeLabels = {
    pageTitle: 'Qualification Types',
    singleLAbel: 'Qualification',
    courselevel_id: 'Course Level',
    hesAqualaim: 'HESA qualification aims',
    welshDescription: 'Welsh Description',
};

export const QualificationTypeList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={QualificationTypeLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField source="Title" label="Short Description" />
                    <ReferenceField
                        reference="CourseLevel"
                        source="courselevel_id"
                        linkType="show"
                        allowEmpty
                    >
                        <TextField source="description" />
                    </ReferenceField>
                    <BooleanField source="current" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const QualificationTypeEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit title={<ShowTitleByDescription />} {...props} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="id" disabled />
                    <TextInput source="Title" label="Short Description" />
                    <TextInput
                        label={QualificationTypeLabels.welshDescription}
                        source="welshDescription"
                    />
                    <ReferenceInput
                        reference="QualificationAim"
                        source="qualification"
                        allowEmpty
                    >
                        <AutocompleteInput source="description" />
                    </ReferenceInput>
                    <TextInput
                        label={QualificationTypeLabels.hesAqualaim}
                        source="hesAqualaim"
                    />
                    <ReferenceInput
                        reference="CourseLevel"
                        source="courselevel_id"
                        label={QualificationTypeLabels.courselevel_id}
                    >
                        <AutocompleteInput optionText="description" />
                    </ReferenceInput>
                    <BooleanInput source="current" />
                    <TextInput source="created_at" disabled />
                    <TextInput source="updated_at" disabled />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const QualificationTypeCreate = (props) => (
    <Create {...props} redirect="edit">
        <SimpleForm>
            <TextInput source="Title" label="Short Description" />
            <TextInput
                label={QualificationTypeLabels.welshDescription}
                source="welshDescription"
            />
            <ReferenceInput
                reference="QualificationAim"
                source="qualification"
                allowEmpty
            >
                <AutocompleteInput source="description" />
            </ReferenceInput>
            <TextInput
                label={QualificationTypeLabels.hesAqualaim}
                source="hesAqualaim"
            />
            <ReferenceInput
                reference="CourseLevel"
                source="courselevel_id"
                label={QualificationTypeLabels.courselevel_id}
            >
                <AutocompleteInput optionText="description" />
            </ReferenceInput>
            <BooleanInput source="current" />
        </SimpleForm>
    </Create>
);

export const QualificationTypeShow = (props) => (
    <Show title={<ShowTitleByDescription />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="Title" label="Short Description" />
            <TextField
                label={QualificationTypeLabels.welshDescription}
                source="welshDescription"
            />
            <ReferenceField
                reference="QualificationAim"
                source="qualification"
                allowEmpty
            >
                <TextField source="description" />
            </ReferenceField>
            <TextField source="qualification" />
            <TextField
                label={QualificationTypeLabels.hesAqualaim}
                source="hesAqualaim"
            />
            <ReferenceField
                reference="CourseLevel"
                source="courselevel_id"
                allowEmpty
            >
                <TextField source="description" />
            </ReferenceField>
            <BooleanField source="current" />
            <TextField source="created_at" />
            <TextField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
